module.exports = __webpack_public_path__ + "static/media/bird_making_home_01.8bc90ad0.gif";